@let o = options;
<div class="cr-dialog" [class.cr-dialog--center]="o.layout === 'center'">
  @if (o.layout === 'center' && o.media) {
    <div class="media-circle" [style.background]="o.media.bg || 'var(--cr-bg-surface-2)'">
      @switch (o.media.kind) {
        @case ('seal') { <img [src]="o.media.url" alt="" /> }
        @case ('symbol') { <span class="material-symbols-rounded sym">{{ o.media.symbol }}</span> }
        @case ('glyph') { <app-social-glyph [code]="o.media.code" [size]="40" /> }
        @default { <cr-icon [name]="o.icon || 'trash'" [size]="36" /> }
      }
      <span class="badge"><cr-icon [name]="o.icon || 'trash'" [size]="16" /></span>
    </div>
  } @else if (!o.hideIcon) {
    <div class="head-row">
      <span class="cr-dialog__icon" [class.cr-dialog__icon--brand]="o.iconTone === 'brand'">
        <cr-icon [name]="o.icon || 'trash'" [size]="24" />
      </span>
      @if (o.media?.kind === 'card') {
        <app-card-front class="thumb" [url]="o.media?.url" />
      }
    </div>
  }

  <div>
    <h2 class="cr-dialog__title">{{ o.title }}</h2>
    @if (o.body) { <p class="cr-dialog__body">{{ o.body }}</p> }
  </div>

  @if (o.impact?.length) {
    <ul class="impact">
      @for (line of o.impact; track $index) { <li><cr-icon name="alert" [size]="16" />{{ line }}</li> }
    </ul>
  }

  @if (o.warning) {
    <div class="cr-alert cr-alert--warning warn"><cr-icon name="alert" [size]="18" /><span>{{ o.warning }}</span></div>
  }

  @if (o.confirmWord) {
    <div class="cr-field">
      <label class="cr-field__label" for="confirm-word">Escribe {{ o.confirmWord }} para confirmar</label>
      <input id="confirm-word" class="cr-input" autocomplete="off" [placeholder]="o.confirmWord"
        [value]="typed()" (input)="typed.set($any($event.target).value)" (keydown.enter)="confirm()" />
    </div>
  }

  <div class="cr-dialog__actions" [class.size-m]="o.size === 'm'">
    <button type="button" class="cr-btn cr-btn--secondary" [class.cr-btn--l]="o.size !== 'm'" (click)="cancel()">{{ o.cancelLabel || 'Cancelar' }}</button>
    <button type="button" class="cr-btn" [class.cr-btn--l]="o.size !== 'm'"
      [class.cr-btn--destructive]="o.tone !== 'primary'" [class.cr-btn--primary]="o.tone === 'primary'"
      [disabled]="!canConfirm()" (click)="confirm()">
      @if (busy()) { <span class="cr-spinner"></span> }
      @else if (o.confirmIcon) { <cr-icon [name]="o.confirmIcon" [size]="18" /> }
      {{ o.confirmLabel }}
    </button>
  </div>
</div>
